import { type Dispatch, type SetStateAction, useRef, useState } from 'react';
import { useSingleFunctionCallOnRender } from './useSingleFunctionCallOnRender';

/*
 * Хук для состояния, которое синхронизируется с начальным значением
 * @param initialValue начальное значение, если объект - обязательно должен быть замемоизирован
 */
export function useSyncedState<S = unknown>(initialValue: S): [S, Dispatch<SetStateAction<S>>] {
    const [state, setState] = useState<S>(initialValue);
    const prevInitialValue = useRef<S>(initialValue);

    useSingleFunctionCallOnRender(
        'Параметры переданные в функцию "useSyncedState" необходимо замемоизировать',

        // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
        prevInitialValue.current !== initialValue,
        () => {
            prevInitialValue.current = initialValue;
            setState(initialValue);
        }
    );

    return [state, setState];
}
